import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { UsersService } from 'src/app/private/services/users.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-add-user',
  imports: [SharedModule],
  templateUrl: './add-user.component.html',
  styleUrl: './add-user.component.scss'
})
export class AddUserComponent {
  @Output() closeDialog = new EventEmitter<any>();
  @Output() reload = new EventEmitter<any>();
  @Input() formAction: string = 'Add';
  @Input() userDataToEdit: any = {};
  user: any = {};
  isSubmitted = false;

  departmentsList: any = [];
  roles: any = [];
  isLoading = false;

  constructor(
    private api: UsersService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.getAllDepartments();
    this.getAllRoles();
  }

  ngOnChanges() {
    if (this.userDataToEdit && this.userDataToEdit.user_id && this.formAction === 'Edit') {
      this.user = this.userDataToEdit;
    }
  }


  prefixOptions = [
    { label: 'Select', value: '' },
    { label: 'Mr', value: 'Mr' },
    { label: 'Ms', value: 'Ms' },
    { label: 'Mrs', value: 'Mrs' }
  ];

  genderOptions = [
    { label: 'Select', value: '' },
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' }
  ];

  statusOptions = [
    { label: 'Select', value: '' },
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Suspended', value: 'Suspended' }
  ];


  getAllRoles() {
    const payload = {
      organization_id: this.localStorage.getOrganizationId()
    }
    this.api.getAllRoles(payload).subscribe({
      next: (res) => {
        this.roles = res || []
      },
      error: (e) => {

      }
    })
  }

  getAllDepartments() {
    const payload = {
      organization_id: this.localStorage.getOrganizationId()
    }
    this.api.getAllDepartment(payload).subscribe({
      next: (res) => {
        this.departmentsList = res || []
        this.departmentsList = this.departmentsList.map((department: any) => {
          return {
            label: department.name,
            value: Number(department.dept_id)
          }
        }
        )
      },
      error: (e) => {

      }
    })
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  saveUser(isValid: any) {
    this.isSubmitted = true;
    if (isValid) {
      this.isLoading = true;
      const payload = {
        ...this.user,
        organization_id: this.localStorage.getOrganizationId(),
        campus_id: this.localStorage.getCampusId()
      }

      if (this.formAction === 'Add') {
        this.api.createUser(payload).subscribe({
          next: (res) => {
            this.isLoading = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User added successfully' });
            this.closeDialog.emit();
            this.reload.emit();
            this.user = {};
          },
          error: (e) => {
            this.isLoading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to add user' });
          }
        })
      } else {
        payload.user_id = this.userDataToEdit.user_id;
        this.api.updateUser(payload).subscribe({
          next: (res) => {
            this.isLoading = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User updated successfully' });
            this.closeDialog.emit();
            this.reload.emit();
          },
          error: (e) => {
            this.isLoading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update user' });
          }
        })
      }
    }
  }

  get lowercase() {
    return /[a-z]/.test(this.user.password);
  }

  get uppercase() {
    return /[A-Z]/.test(this.user.password);
  }

  get numeric() {
    return /\d/.test(this.user.password);
  }

  get minLength() {
    return this.user.password.length >= 8;
  }

  get noWhitespace() {
    return !/\s/.test(this.user.password);
  }

  get validPassword() {
    return this.lowercase && this.uppercase && this.numeric && this.minLength && this.noWhitespace;
  }
}
